import styled from 'styled-components';

export const StyledAuthorizedResult = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  place-items: center;
`;
